import React from "react";
import Card from "../../components/page/Card";
import TabList from "../../components/Tab/TabList";
import TabButton from "../../components/Tab/TabButton";
import TabContent from "../../components/Tab/TabContent";
import ButtonRounded from "../../components/buttons/ButtonRounded";
import TabPane from "../../components/Tab/TabPane";
import AtivosDataTable from "./Colaboradores/AtivosDataTable";
import AdmissoesDataTable from "./Colaboradores/AdmissoesDataTable";
import DemissoesDataTable from "./Colaboradores/DemissoesDataTable";
import SolicitarAdmissaoModal from "./Colaboradores/SolicitarAdmissaoModal";
import SolicitarFeriasModal from "./Colaboradores/SolicitarFeriasModal";
import SolicitarDemissaoModal from "./Colaboradores/SolicitarDemissaoModal";
import ReajustarSalarioModal from "./Colaboradores/ReajustarSalarioModal";
import EditarReajusteModal from "./Colaboradores/EditarReajusteModal";
import CommonSwal from "../../components/Swal/commonSwal";
import OptionsSwal from "../../components/Swal/optionsSwal";
import AprovarAdmissaoModal from "./Colaboradores/AprovarAdmissaoModal";
import AprovarDemissaoModal from "./Colaboradores/AprovarDemissaoModal";
import { AppContext } from "../../contexts/AppContext";
import { FaPlus } from "react-icons/fa6";
import useApi from "../../hooks/useApi";
import ColaboradoresApiClient from "../../api/colaboradores";
import Validation from "../../helpers/Validation";
import Format from "../../helpers/Format";
import ErrorSwal from "../../components/Swal/errorSwal";

function Colaboradores() {
  const [values, setValues] = React.useState({});
  const [colaboradoresAtivos, setColaboradoresAtivos] = React.useState([]);
  const [colaboradoresAdmissoes, setColaboradoresAdmissoes] = React.useState(
    []
  );
  const [colaboradoresDemissoes, setColaboradoresDemissoes] = React.useState(
    []
  );
  const [solicitarAdmissaoModal, setSolicitarAdmissaoModal] =
    React.useState(false);
  const [solicitarFeriasModal, setSolicitarFeriasModal] = React.useState(false);
  const [solicitarDemissaoModal, setSolicitarDemissaoModal] =
    React.useState(false);
  const [historicoSalario, setHistoricoSalario] = React.useState([]);
  const [reajustarSalarioModal, setReajustarSalarioModal] =
    React.useState(false);
  const [editarReajusteModal, setEditarReajusteModal] = React.useState(false);
  const [aprovarAdmissaoModal, setAprovarAdmissaoModal] = React.useState(false);
  const [visualizar, setVisualizar] = React.useState(false);
  const [aprovarDemissaoModal, setAprovarDemissaoModal] = React.useState(false);
  const { baseUrl, session } = React.useContext(AppContext);

  const { request: getColaboradoresAtivos, data: colaboradoresAtivosResponse } =
    useApi(ColaboradoresApiClient.getAtivos);
  const {
    request: getColaboradoresAdmissoes,
    data: colaboradoresAdmissoesResponse,
  } = useApi(ColaboradoresApiClient.getAdmissoes);
  const {
    request: getColaboradoresDemissoes,
    data: colaboradoresDemissoesResponse,
  } = useApi(ColaboradoresApiClient.getDemissoes);
  const solicitarNovaAdmissaoApi = useApi(
    ColaboradoresApiClient.solicitarNovaAdmissao
  );
  const solicitarFeriasApi = useApi(ColaboradoresApiClient.solicitarFerias);
  const reajustarSalarioApi = useApi(ColaboradoresApiClient.reajustarSalario);
  const { request: getSalarioHistorico, data: salarioHistoricoResponse } =
    useApi(ColaboradoresApiClient.getSalarioHistorico);
  const putReajusteSalarioApi = useApi(
    ColaboradoresApiClient.putReajusteSalario
  );
  const deleteReajusteSalarioApi = useApi(
    ColaboradoresApiClient.deleteReajusteSalario
  );
  const { request: getDemissao } = useApi(ColaboradoresApiClient.getDemissao);
  const solicitarDemissaoApi = useApi(ColaboradoresApiClient.solicitarDemissao);
  const { request: solicitarCancelamentoDemissaoApi } = useApi(
    ColaboradoresApiClient.solicitarCancelamentoDemissao
  );
  const { request: cancelarDemissaoApi } = useApi(
    ColaboradoresApiClient.cancelarDemissao
  );
  const aprovarDemissaoApi = useApi(ColaboradoresApiClient.aprovarDemissao);
  const aprovarAdmissaoApi = useApi(ColaboradoresApiClient.aprovarAdmissao);
  const { request: solicitarCancelamentoAdmissaoApi } = useApi(
    ColaboradoresApiClient.solicitarCancelamentoAdmissao
  );
  const { request: cancelarAdmissaoApi } = useApi(
    ColaboradoresApiClient.cancelarAdmissao
  );
  const aprovarReajusteApi = useApi(ColaboradoresApiClient.aprovarReajuste);

  //Busca colaboradores ao renderizar tela
  React.useEffect(() => {
    if (!session?.empresa) return;
    getColaboradoresAtivos(session.empresa.replace(/E/gi, ""));
  }, [getColaboradoresAtivos, session.empresa]);

  //Define estado ao receber colaboradores
  React.useEffect(() => {
    if (!colaboradoresAtivosResponse) return;
    setColaboradoresAtivos(colaboradoresAtivosResponse);
  }, [colaboradoresAtivosResponse]);

  //Busca colaboradores ao renderizar tela
  React.useEffect(() => {
    if (!session?.empresa) return;
    getColaboradoresAdmissoes(session.empresa.replace(/E/gi, ""));
  }, [getColaboradoresAdmissoes, session.empresa]);

  //Define estado ao receber colaboradores
  React.useEffect(() => {
    if (!colaboradoresAdmissoesResponse) return;
    setColaboradoresAdmissoes(colaboradoresAdmissoesResponse);
  }, [colaboradoresAdmissoesResponse]);

  //Busca colaboradores ao renderizar tela
  React.useEffect(() => {
    if (!session?.empresa) return;
    getColaboradoresDemissoes(session.empresa.replace(/E/gi, ""));
  }, [getColaboradoresDemissoes, session.empresa]);

  //Define estado ao receber colaboradores
  React.useEffect(() => {
    if (!colaboradoresDemissoesResponse) return;
    setColaboradoresDemissoes(colaboradoresDemissoesResponse);
  }, [colaboradoresDemissoesResponse]);

  //Define estado ao receber colaboradores
  React.useEffect(() => {
    if (!salarioHistoricoResponse) return;
    var solicitacao = null;
    if (salarioHistoricoResponse?.solicitacao.length > 0) {
      solicitacao = salarioHistoricoResponse?.solicitacao.reduce(
        (acc, solicitacao) => {
          acc[solicitacao.descricao] = solicitacao.valor;
          return acc;
        },
        {}
      );
      solicitacao.status = 2;
      solicitacao.solicitacao_uid =
        salarioHistoricoResponse?.solicitacao[0].ref_uid;
      solicitacao.mes_inicial = `${solicitacao.mes_inicial}-01`;
    }
    setHistoricoSalario(
      solicitacao
        ? [solicitacao, ...salarioHistoricoResponse.historico]
        : salarioHistoricoResponse.historico
    );
  }, [salarioHistoricoResponse]);

  const togSolicitarAdmissaoModal = () => {
    setValues({});
    setSolicitarAdmissaoModal(true);
  };

  const togSolicitarFeriasModal = React.useCallback((uid) => {
    setValues({ uid });
    setSolicitarFeriasModal(true);
  }, []);

  const togSolicitarDemissaoModal = React.useCallback((uid, data_admissao) => {
    setValues({
      uid,
      data_admissao,
      inserir_faltas: false,
      possui_horas_extras: false,
      descontos: false,
    });
    setVisualizar(false);
    setSolicitarDemissaoModal(true);
  }, []);

  const togVisualizarDemissaoModal = React.useCallback(
    async (uid) => {
      const response = await getDemissao(
        session.empresa.replace(/E/gi, ""),
        uid
      );
      if (!response) return;
      const newValues = response.solicitacoes_adicionais.reduce(
        (acc, solicitacao) => {
          acc[solicitacao.descricao] = solicitacao.valor;
          return acc;
        },
        {}
      );

      setValues({
        ...newValues,
        faltas: parseInt(newValues?.faltas),
        inserir_faltas: !!newValues?.faltas,
        possui_horas_extras: !!newValues?.horas_extras,
        descontos: !!newValues?.outros_descontos,
      });
      setVisualizar(true);
      setSolicitarDemissaoModal(true);
    },
    [getDemissao, session.empresa]
  );

  const togReajustarSalarioModal = React.useCallback(
    async (uid, salario_atual) => {
      const response = await getSalarioHistorico(
        session.empresa.replace(/E/gi, ""),
        uid
      );
      if (!response) return;
      setValues({ uid, salario_atual });
      setReajustarSalarioModal(true);
    },
    [getSalarioHistorico, session.empresa]
  );

  const togEditarReajusteModal = (uid_reajuste) => {
    setValues((prevValues) => ({
      uid: prevValues?.uid,
      salario_atual: prevValues?.salario_atual,
      uid_reajuste,
    }));
    setReajustarSalarioModal(false);
    setEditarReajusteModal(true);
  };

  const togAprovarAdmissaoModal = React.useCallback(
    (uid, categoria, dependentes) => {
      setValues({ uid, categoria, dependentes });
      setAprovarAdmissaoModal(true);
    },
    []
  );

  const excluirAdmissao = React.useCallback(
    async (uid) => {
      OptionsSwal({
        title: "Tem certeza que deseja excluir essa admissão?",
        icon: "question",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await cancelarAdmissaoApi(
            session.empresa.replace(/E/gi, ""),
            uid
          );
          if (!response) return;
          getColaboradoresAdmissoes(session.empresa.replace(/E/gi, ""));
        }
      });
    },
    [cancelarAdmissaoApi, getColaboradoresAdmissoes, session.empresa]
  );

  const solicitarCancelamentoAdmissao = React.useCallback(
    async (uid) => {
      OptionsSwal({
        title:
          "Você tem certeza que deseja solicitar o cancelamento dessa admissão?",
        icon: "question",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await solicitarCancelamentoAdmissaoApi(
            session.empresa.replace(/E/gi, ""),
            uid,
            session?.user_guid
          );
          if (!response) return;
          CommonSwal({
            icon: "success",
            title: "Solicitação enviada com sucesso",
          });
          getColaboradoresAdmissoes(session.empresa.replace(/E/gi, ""));
        }
      });
    },
    [
      getColaboradoresAdmissoes,
      session.empresa,
      session?.user_guid,
      solicitarCancelamentoAdmissaoApi,
    ]
  );

  const cancelarAdmissao = React.useCallback(
    async (uid) => {
      OptionsSwal({
        title: "Tem certeza que deseja cancelar essa admissão?",
        icon: "question",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await cancelarAdmissaoApi(
            session.empresa.replace(/E/gi, ""),
            uid
          );
          if (!response) return;
          getColaboradoresAdmissoes(session.empresa.replace(/E/gi, ""));
        }
      });
    },
    [cancelarAdmissaoApi, getColaboradoresAdmissoes, session.empresa]
  );

  const solicitarCancelamentoDemissao = React.useCallback(
    async (uid) => {
      OptionsSwal({
        title:
          "Você tem certeza que deseja solicitar o cancelamento desta demissão?",
        icon: "question",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await solicitarCancelamentoDemissaoApi(
            session.empresa.replace(/E/gi, ""),
            uid,
            session?.user_guid
          );
          if (!response) return;
          getColaboradoresAtivos(session.empresa.replace(/E/gi, ""));
          getColaboradoresDemissoes(session.empresa.replace(/E/gi, ""));
        }
      });
    },
    [
      getColaboradoresAtivos,
      getColaboradoresDemissoes,
      session.empresa,
      session?.user_guid,
      solicitarCancelamentoDemissaoApi,
    ]
  );

  const togAprovarDemissaoModal = React.useCallback(
    (uid, tipo_demissao, categoria) => {
      setValues({ uid, tipo_demissao, categoria });
      setAprovarDemissaoModal(true);
    },
    []
  );

  const cancelarDemissao = React.useCallback(
    async (uid) => {
      OptionsSwal({
        title:
          "Você tem certeza que deseja confirmar o cancelamento desta solicitação de demissão?",
        icon: "question",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await cancelarDemissaoApi(
            session.empresa.replace(/E/gi, ""),
            uid
          );
          if (!response) return;
          getColaboradoresDemissoes(session.empresa.replace(/E/gi, ""));
        }
      });
    },
    [cancelarDemissaoApi, getColaboradoresDemissoes, session.empresa]
  );

  const solicitarDemissao = async () => {
    const hasDataAviso =
      values?.aviso_previo && parseInt(values?.aviso_previo) !== 3;
    const hasReducaoAviso =
      values?.aviso_previo &&
      parseInt(values?.aviso_previo) === 2 &&
      values?.tipo_demissao &&
      parseInt(values?.tipo_demissao) !== 3;

    const formData = new FormData();
    formData.append("tipo_demissao", values?.tipo_demissao);
    formData.append("aviso_previo", values?.aviso_previo);
    formData.append("data_demissao", values?.data_demissao);
    if (hasDataAviso) formData.append("data_aviso", values?.data_aviso || "");
    if (hasDataAviso) formData.append("dias_aviso", values?.dias_aviso || "");
    if (hasReducaoAviso)
      formData.append("reducao_aviso", values?.reducao_aviso || "");
    if (values?.inserir_faltas) formData.append("faltas", values?.faltas || "");
    if (values?.possui_horas_extras)
      formData.append("horas_extras", values?.horas_extras || "");
    if (values?.descontos)
      formData.append("outros_descontos", values?.outros_descontos || "");

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    if (!hasDataAviso) formData.append("data_aviso", "");
    if (!hasDataAviso) formData.append("dias_aviso", "");
    if (!hasReducaoAviso) formData.append("reducao_aviso", "");
    if (!values?.inserir_faltas) formData.append("faltas", "");
    if (!values?.possui_horas_extras) formData.append("horas_extras", "");
    if (!values?.descontos) formData.append("outros_descontos", "");

    const response = await solicitarDemissaoApi.request(
      session.empresa.replace(/E/gi, ""),
      values?.uid,
      formData,
      session?.user_guid
    );
    if (!response) return;
    setSolicitarDemissaoModal(false);
    CommonSwal({ title: "Demissão solicitada com sucesso", icon: "success" });
    getColaboradoresDemissoes(session.empresa.replace(/E/gi, ""));
    getColaboradoresAdmissoes(session.empresa.replace(/E/gi, ""));
  };

  const aprovarDemissao = async (tipo_demissao, categoria) => {
    const formData = new FormData();
    formData.append("recisao", values?.termoRescisao);
    formData.append("extrato_fgts", values?.extratoFgts);

    if (tipo_demissao === 2 && categoria !== 2)
      if (Validation.verificarForm(formData))
        return ErrorSwal({
          text: "Favor preencher todos os dados obrigatórios.",
        });

    formData.append("aviso_previo", values?.avisoPrevio);

    if (tipo_demissao === 3 && categoria !== 2)
      if (Validation.verificarForm(formData))
        return ErrorSwal({
          text: "Favor preencher todos os dados obrigatórios.",
        });

    formData.append("seguro_desemprego", values?.seguroDesemprego);

    if ([1, 4].includes(tipo_demissao) && categoria !== 2)
      if (Validation.verificarForm(formData))
        return ErrorSwal({
          text: "Favor preencher todos os dados obrigatórios.",
        });

    formData.append("demonstrativo_fgts", values?.fgts);

    if (categoria == 2)
      if (Validation.verificarForm(formData))
        return ErrorSwal({
          text: "Favor preencher todos os dados obrigatórios.",
        });

    const response = await aprovarDemissaoApi.request(
      session.empresa.replace(/E/gi, ""),
      values?.uid,
      formData
    );
    if (!response) return;
    setAprovarDemissaoModal(false);
    CommonSwal({ title: "Demissão aprovada com sucesso", icon: "success" });
    getColaboradoresDemissoes(session.empresa.replace(/E/gi, ""));
    getColaboradoresAtivos(session.empresa.replace(/E/gi, ""));
  };

  const solicitarFerias = async () => {
    const formData = new FormData();
    formData.append("inicio_ferias_colaborador", values?.inicio_ferias);
    formData.append("dias_ferias_colaborador", values?.dias_ferias);
    formData.append("fim_ferias_colaborador", values?.fim_ferias);
    formData.append("data_retorno_colaborador", values?.data_retorno);
    formData.append(
      "vender_terco_ferias",
      values?.vender_terco_ferias ? "1" : "0"
    );

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await solicitarFeriasApi.request(
      session.empresa.replace(/E/gi, ""),
      values?.uid,
      formData,
      session?.user_guid
    );
    if (!response) return;
    setSolicitarFeriasModal(false);
    CommonSwal({ title: "Férias solicitadas com sucesso", icon: "success" });
    getColaboradoresAdmissoes(session.empresa.replace(/E/gi, ""));
  };

  const solicitarAdmissao = async () => {
    const formData = new FormData();
    formData.append("documento", Format.formatCNPJCPF(values?.cpf));

    if (Validation.validaCpf(values?.cpf))
      return ErrorSwal({
        text: "CPF inválido!",
      });

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await solicitarNovaAdmissaoApi.request(
      session.empresa.replace(/E/gi, ""),
      formData
    );
    if (!response) return;
    setSolicitarAdmissaoModal(false);
    getColaboradoresAdmissoes(session.empresa.replace(/E/gi, ""));
    window.open(
      `${process.env.REACT_APP_BACKEND_HOST}${process.env.REACT_APP_PREFIX}/colaboradores/Colaborador/admissao/${response.uid}`,
      "_self"
    );
  };

  const aprovarAdmissao = async () => {
    const formData = new FormData();

    if (values.categoria === 1) {
      formData.append("contrato_experiencia", values?.contrato_experiencia);
      formData.append("solicitacao_transporte", values?.solicitacao_transporte);

      if (values.dependentes)
        formData.append("salario_familia", values?.salario_familia);
    } else {
      formData.append("ficha_registro", values?.ficha_registro);
    }
    formData.append("data_admissao", values?.data_admissao);
    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await aprovarAdmissaoApi.request(
      session.empresa.replace(/E/gi, ""),
      values?.uid,
      formData
    );
    if (!response) return;
    setAprovarAdmissaoModal(false);
    CommonSwal({ title: "Admissão aprovada com sucesso", icon: "success" });
    getColaboradoresAtivos(session.empresa.replace(/E/gi, ""));
    getColaboradoresAdmissoes(session.empresa.replace(/E/gi, ""));
  };

  const salvarReajuste = async () => {
    const formData = new FormData();
    formData.append("valor", Format.formatCNPJCPF(values?.novo_salario));
    formData.append("mes_inicial", Format.formatCNPJCPF(values?.mes_reajuste));

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    if (values?.novo_salario <= values?.salario_atual)
      return ErrorSwal({
        text: "O campo novo salário deve ser maior que o salário atual.",
      });

    const response = await putReajusteSalarioApi.request(
      session.empresa.replace(/E/gi, ""),
      values?.uid,
      values?.uid_reajuste,
      formData
    );
    if (!response) return;
    setValues({
      salario_atual: values?.salario_atual,
      uid: values?.uid,
    });
    setEditarReajusteModal(false);
    setReajustarSalarioModal(true);
    await getSalarioHistorico(session.empresa.replace(/E/gi, ""), values?.uid);
  };

  const solicitarReajuste = async () => {
    const formData = new FormData();
    formData.append("valor", Format.formatCNPJCPF(values?.novo_salario));
    formData.append("mes_inicial", Format.formatCNPJCPF(values?.mes_reajuste));

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    if (values?.novo_salario <= values?.salario_atual)
      return ErrorSwal({
        text: "O campo novo salário deve ser maior que o salário atual.",
      });

    const response = await reajustarSalarioApi.request(
      session.empresa.replace(/E/gi, ""),
      values?.uid,
      formData,
      session?.user_guid
    );
    if (!response) return;
    await getSalarioHistorico(session.empresa.replace(/E/gi, ""), values?.uid);
  };

  const apagarReajuste = async (uid_reajuste) => {
    const response = await deleteReajusteSalarioApi.request(
      session.empresa.replace(/E/gi, ""),
      values?.uid,
      uid_reajuste
    );
    if (!response) return;
    await getSalarioHistorico(session.empresa.replace(/E/gi, ""), values?.uid);
  };

  const aprovarReajuste = async (uid_reajuste, novo_salario) => {
    OptionsSwal({
      title: "Tem certeza que deseja aprovar essa solicitação?",
      icon: "question",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await aprovarReajusteApi.request(
          session.empresa.replace(/E/gi, ""),
          values?.uid,
          uid_reajuste
        );
        if (!response) return;
        setValues((prevValues) => ({
          ...prevValues,
          salario_atual: novo_salario,
        }));
        getColaboradoresAtivos(session.empresa.replace(/E/gi, ""));
        await getSalarioHistorico(
          session.empresa.replace(/E/gi, ""),
          values?.uid
        );
      }
    });
  };

  return (
    <>
      <Card>
        <div className="row my-3">
          <div
            style={{ justifyContent: "end", display: "flex", gap: "0.5rem" }}
          >
            <ButtonRounded
              color="primary"
              onClick={() => {
                window.location.href = `${baseUrl}colaboradores/JornadaTrabalho`;
              }}
            >
              Jornada de trabalho
            </ButtonRounded>
            <ButtonRounded
              color="success"
              onClick={() => {
                togSolicitarAdmissaoModal();
              }}
              icon={<FaPlus />}
            >
              Solicitar admissão
            </ButtonRounded>
          </div>
        </div>
        <TabList>
          <TabButton href="ativosTab" ativo={true}>
            Ativos
          </TabButton>
          <TabButton href="admissoesTab">Admissões</TabButton>
          <TabButton href="demissoesTab">Demissões</TabButton>
        </TabList>
        <TabContent>
          <TabPane id="ativosTab" ativo={true}>
            <AtivosDataTable
              colaboradores={colaboradoresAtivos}
              togSolicitarFeriasModal={togSolicitarFeriasModal}
              togSolicitarDemissaoModal={togSolicitarDemissaoModal}
              togReajustarSalarioModal={togReajustarSalarioModal}
            />
          </TabPane>
          <TabPane id="admissoesTab">
            <AdmissoesDataTable
              colaboradores={colaboradoresAdmissoes}
              excluirAdmissao={excluirAdmissao}
              solicitarCancelamentoAdmissao={solicitarCancelamentoAdmissao}
              cancelarAdmissao={cancelarAdmissao}
              togAprovarAdmissaoModal={togAprovarAdmissaoModal}
            />
          </TabPane>
          <TabPane id="demissoesTab">
            <DemissoesDataTable
              colaboradores={colaboradoresDemissoes}
              togVisualizarDemissaoModal={togVisualizarDemissaoModal}
              solicitarCancelamentoDemissao={solicitarCancelamentoDemissao}
              togAprovarDemissaoModal={togAprovarDemissaoModal}
              cancelarDemissao={cancelarDemissao}
            />
          </TabPane>
        </TabContent>
      </Card>
      <SolicitarAdmissaoModal
        isOpen={solicitarAdmissaoModal}
        setIsOpen={setSolicitarAdmissaoModal}
        solicitarAdmissao={solicitarAdmissao}
        valuesHook={{ values, setValues }}
      />
      <SolicitarFeriasModal
        isOpen={solicitarFeriasModal}
        setIsOpen={setSolicitarFeriasModal}
        solicitarFerias={solicitarFerias}
        valuesHook={{ values, setValues }}
      />
      <SolicitarDemissaoModal
        isOpen={solicitarDemissaoModal}
        setIsOpen={setSolicitarDemissaoModal}
        solicitarDemissao={solicitarDemissao}
        valuesHook={{ values, setValues }}
        visualizar={visualizar}
      />
      <ReajustarSalarioModal
        isOpen={reajustarSalarioModal}
        setIsOpen={setReajustarSalarioModal}
        solicitarReajuste={solicitarReajuste}
        apagarReajuste={apagarReajuste}
        historicoSalario={historicoSalario}
        valuesHook={{ values, setValues }}
        togEditarReajusteModal={togEditarReajusteModal}
        aprovarReajuste={aprovarReajuste}
      />
      <EditarReajusteModal
        isOpen={editarReajusteModal}
        setIsOpen={setEditarReajusteModal}
        editarReajuste={salvarReajuste}
        valuesHook={{ values, setValues }}
      />
      <AprovarAdmissaoModal
        isOpen={aprovarAdmissaoModal}
        setIsOpen={setAprovarAdmissaoModal}
        aprovarAdmissao={aprovarAdmissao}
        valuesHook={{ values, setValues }}
      />
      <AprovarDemissaoModal
        isOpen={aprovarDemissaoModal}
        setIsOpen={setAprovarDemissaoModal}
        aprovarDemissao={aprovarDemissao}
        valuesHook={{ values, setValues }}
      />
    </>
  );
}

export default Colaboradores;
